/*
 * Copyright (c) 2023 Shabélab inc.
 * All Rights Reserved.
 * 
 * This software is the property of Shabélab inc.
 * 
 * This software is supplied "AS IS" without any warranties and support.
 * 
 * Distribution, reproduction, and modification of this software or 
 * any derivative works are forbidden without written permission from 
 * Shabélab inc.
 */

import { combineReducers } from 'redux'
import user from './userReducer'

export default combineReducers({
  user
})
